import script from "./orderList.vue?vue&type=script&lang=ts&setup=true"
export * from "./orderList.vue?vue&type=script&lang=ts&setup=true"

import "./orderList.vue?vue&type=style&index=0&id=36a42672&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36a42672"]])

export default __exports__